<template>
  <div>
    <content-component
        :datafile="mr"/>
    <v-col cols="10" >

    </v-col>
    <v-fab-transition>
      <v-btn absolute fab small dark color="cyan"
             bottom right
             onclick="location.href='#'">
        <v-icon>{{ icons.mdiArrowUp }}</v-icon>
      </v-btn>
    </v-fab-transition>

    <core-footer />
  </div>
</template>

<script>
import {mr} from '@/data/motion_recognition.js'
import ContentComponent from "../components/motion_recognition";
import {mdiArrowUp} from '@mdi/js'
import 'video.js/dist/video-js.css'

export default {
  name: 'MotionRecognition',
  components: {ContentComponent,
              CoreFooter: () => import ('@/components/core/Footer')},
  data: () => ({
    mr,
    icons: {
      mdiArrowUp
    },
    
  }),


}
</script>
<style>

</style>
